module.exports = __webpack_public_path__ + "media/images/flags/kh-7b33804c913e2285c5387a26b6a95a08.svg";